import type { BrandConfig } from '@estimating/branding';
import { createRequiredContext } from '../shared/create-required-context';

export const [BrandContext, useBrand] = createRequiredContext<BrandConfig>('BrandContext');
